// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"272":"admin-login","605":"shop-verify-success","806":"user","883":"shop","884":"admin"}[chunkId] + "." + {"272":"ebfe1a20","605":"294f75d8","806":"aa342fe4","883":"81e0ad67","884":"8bd218d7"}[chunkId] + ".css";
};